/**
 * Unhook — Remove YouTube Recommended & Shorts
 *
 * Declares a single web-accessible resource, `/js/unhook-yt.js`, scoped to YouTube
 * (`https://www.youtube.com/*` and `https://m.youtube.com/*`) rather than to every
 * origin. The resource is genuinely unreachable from anywhere else, so a negative
 * result off YouTube says nothing — only that origin can detect it. From YouTube the
 * vendor-named script is served at a fixed URL, making the fetch conclusive.
 *
 * Manifest verified against version 1.6.9.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'khncfooichmfjbepaaaebmommgaepoid';

export const unhook: ExtensionDefinition = {
  id: ID,
  name: 'Unhook - Remove YouTube Recommended & Shorts',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1_000_000,
  requiredOrigin: 'https://www.youtube.com',
  notes:
    'Single WAR (js/unhook-yt.js) scoped to youtube.com, so only that origin can detect ' +
    'it — a negative result elsewhere is inconclusive. From YouTube the fetch is conclusive.',
  signals: [
    {
      id: 'war-unhook-yt-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch js/unhook-yt.js — the vendor-named content script, static but only ' +
        'exposed to YouTube origins.',
      weight: 1,
      run: () => probeFetch(ID, 'js/unhook-yt.js'),
    },
  ],
};
